import { render, staticRenderFns } from "./SlcCollabBatchSelect.vue?vue&type=template&id=035196ce&"
import script from "./SlcCollabBatchSelect.vue?vue&type=script&lang=ts&"
export * from "./SlcCollabBatchSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
